export default __webpack_public_path__ + "static/media/browse.e4b381be.png";